import styled from "styled-components"
import Image from "../../image/image.component"

export const CMImage = styled(Image)(props => ({
    border: '6px solid rgb(255, 255, 255)',
    boxShadow: 'rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 20px',
    width: 'calc(100% - 30px)',
    margin: '8px auto',
    display: 'block',
    '@media (max-width: 1023px)': {
        width: '160px',
        height: '160px',
        objectFit: 'cover',
    },
}));